export default __webpack_public_path__ + "static/media/107.4ee92802.jpg";